var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    stroke: "#ECE9E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 16.3335C24.7783 16.3335 22.1667 18.9452 22.1667 22.1668C22.1667 25.3885 24.7783 28.0002 28 28.0002C31.2217 28.0002 33.8333 25.3885 33.8333 22.1668C33.8333 18.9452 31.2217 16.3335 28 16.3335ZM24.5 22.1668C24.5 20.2338 26.067 18.6668 28 18.6668C29.933 18.6668 31.5 20.2338 31.5 22.1668C31.5 24.0998 29.933 25.6668 28 25.6668C26.067 25.6668 24.5 24.0998 24.5 22.1668Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 40.8335C26.2027 40.8335 23.6015 40.4254 21.648 39.5704C20.689 39.1507 19.7137 38.55 19.1471 37.6805C18.849 37.2232 18.6606 36.6845 18.6668 36.0831C18.6729 35.4872 18.869 34.9163 19.1986 34.3851C20.7962 31.8101 24.0646 29.1668 28 29.1668C31.9354 29.1668 35.2038 31.8101 36.8014 34.3851C37.131 34.9163 37.3271 35.4872 37.3332 36.0831C37.3394 36.6845 37.151 37.2232 36.853 37.6805C36.2863 38.55 35.311 39.1507 34.352 39.5704C32.3985 40.4254 29.7973 40.8335 28 40.8335ZM21.1813 35.6152C21.0277 35.8628 21.0009 36.0218 21 36.107C20.9992 36.1867 21.0197 36.2803 21.1019 36.4065C21.2958 36.704 21.7666 37.0753 22.5836 37.4329C24.182 38.1325 26.4521 38.5002 28 38.5002C29.5479 38.5002 31.818 38.1325 33.4165 37.4329C34.2334 37.0753 34.7042 36.704 34.8981 36.4065C34.9803 36.2803 35.0008 36.1867 35 36.107C34.9991 36.0218 34.9723 35.8628 34.8187 35.6152C33.5095 33.5051 30.8984 31.5002 28 31.5002C25.1016 31.5002 22.4905 33.5051 21.1813 35.6152Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowIcon);
export default __webpack_public_path__ + "static/media/flowIcon.03212cfeddb63457c49d451a13c1e57a.svg";
export { ForwardRef as ReactComponent };